import {ICodigoProducto} from './ICodigoProducto';
import {Categoria} from '../class/Categoria';
/**
 * Created by Ricardo on 18-11-2017.
 */

export const PUBLICADO = 'PUBLICADO';
export const NO_PUBLICADO = 'NO_PUBLICADO';
export const DESCONTINUADO = 'DESCONTINUADO';
export const EXONERADO = 'EXONERADO';

export type ESTADOS_PRODUCTO = typeof PUBLICADO | typeof NO_PUBLICADO | typeof DESCONTINUADO | typeof EXONERADO;

export interface IProducto {
  id?: number;
  nombre?: string;
  nombreCorto?: string;
  imagen?: string;
  descipcion?: string;
  detalle?: string;
  especificaciones?: any;
  estado?: ESTADOS_PRODUCTO;
  esPublicado: boolean;
  seleccionSF?: number;
  subEstado?: string;
  orden?: number;
  ordenEn?: number;
  marcaId?: number;
  marca?: any;
  codigos?: ICodigoProducto[];
  codigoProductoId?: number;
  fecCreacion?: Date;
  creadoPor?: string;
  fecModificacion?: Date;
  modificadoPor?: string;
  arbolCategorias?: Categoria[];
  totalProductosRelacionados?: number;
  totalProductosComplementarios?: number;
  totalProductosAlternativos?: number;
  totalCodigos?: number;
  totalFotosVideos?: number;
}



// WEBPACK FOOTER //
// /app/src/model/interface/IProducto.ts